import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as cost from "./style.module.scss";
import { TaxDeduction } from "../../../../TaxDeduction";
import { Modal } from '../../../../Modal';

export const Cost = ({ widget, free=false, accessLimited }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={cost.cost}>
      <div className="container">
        <div className={cost.cost_wrapper}>

          <div className={cost.cost_wrapperTop}>
            <p className={cost.cost_wrapperTop_suptitle}>Онлайн-курс</p>
            <h3 className={cost.cost_wrapperTop_title}>
              Целеполагание <br/>
              по&nbsp;SMART
            </h3>
            <div className={cost.cost_wrapperTop_desc}>
              <p>6&nbsp;уроков от&nbsp;Александра Згода</p>
              <p>Более 30&nbsp;упражнений</p>
              <p>Тесты, практические задания</p>
            </div>
          </div>

          <div className={cost.cost_wrapperBottom}>
            <div className={cost.oldCost}>
              15 000 <span className={cost.cost__rf}>&#8381;</span>
            </div>
            {
              !free ?
                <div className={cost.newCost}>
                  9 900 <span className={cost.cost__rf}>&#x20BD;</span>
                </div>
                :
                <div className={cost.newCost}>
                  БЕСПЛАТНО
                </div>
            }

            <div className={main.btnBlock}>
              <button className={`btn ${main.mainBtn} ${cost.costBtn}`} onClick={()=>{setShowModal(true)}}>
                {
                  !free ? "Купить" : "Получить"
                }
              </button>
            </div>
          </div>

        </div>
        {
          !free && <TaxDeduction margin={"30px 0 0"} color={"#fff"} align={"center"}/>
        }
        {
          accessLimited &&
          <p style={{ margin: "30px 0 0", color: "#fff", textAlign: "center" }}>
            Бесплатный доступ действителен в&nbsp;течение 7&nbsp;дней
          </p>
        }
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
}
